import React from 'react';
import InquiryList from './InquiryList';

const Dashboard = () => {
  return (
    <div className="min-h-screen flex flex-col">
      {/* Header */}
      <header className="bg-blue-500 text-white px-4 py-3 text-xl">
        Employee Dashboard
      </header>
      {/* Main Content */}
      <main className="p-6 flex-1 bg-gray-100">
        <h1 className="text-2xl font-bold mb-4">All Inquiries</h1>
        <InquiryList />
      </main>
    </div>
  );
};

export default Dashboard;
